import * as types from '../actions/action-types';
import {pickLinkQuery} from '../services/utils';

export function mode(state = {siteProfile: {}, query: {}, linkQuery: {}, metaSiteApps: {items: []}, experiments: {}}, action) {
  switch (action.type) {
    case types.RECEIVE_EXPERIMENTS:
      return {...state, experiments: action.experiments};

    case types.CHANGE_VERTICAL:
      return {...state, siteProfile: {...state.siteProfile, vertical: action.vertical}};

    case types.SET_MARKET:
      return {...state, market: action.market, baseUrl: action.baseUrl, origin: action.origin, fullUrl: action.fullUrl};

    case types.SET_QUERY:
      return {...state, query: action.query, linkQuery: pickLinkQuery(action.query, state.market)};

    case types.SET_ENVIRONMENT:
      return {...state, isProduction: action.isProduction};

    case types.SET_LANG:
      return {...state, lang: action.lang};

    case types.ERROR_PAGE:
      return {...state, errorPage: {message: action.message, status: action.status}};


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/mode.js